import { getNestedValueByPath } from '../common/utils';
import da from './_da';
import en from './_en';

const languages = { da, en };
const defaultLanguageCode = 'en';
const allowedLanguages = Object.keys(languages);

function getDictionary(languageCode) {
  if (!languageCode) {
    throw new Error('Language code is mandatory');
  }

  const language = languages[languageCode];

  if (!language) {
    throw new Error(`Unable to find language with code ${languageCode}`);
  }

  return language;
}

function getTranslatedText(message, modulePath, languageCode, replacements) {
  const translationModule = getNestedValueByPath(getDictionary(languageCode), modulePath);
  const translatedMessage = translationModule[message];

  if (replacements) {
    return translatedMessage.replace(/{(.+?)}/g, (match, captured) => replacements[captured] || '');
  }

  if (!translatedMessage) {
    throw new Error(
      `ERROR: translation for message "${message}" could not be found.
      (translationModule: ${translationModule})
      (modulePath: ${modulePath})`
    );
  }

  return translatedMessage;
}

function readLanguageFromUrl(url) {
  const folders = url.split('/');

  if (!folders || folders.length < 2) {
    return null;
  }

  return folders[1];
}

function isSupported(languageCode) {
  return !!languages[languageCode];
}

function getDefaultLanguageCode() {
  return defaultLanguageCode;
}

function findSupportedLanguageCode(languageCodes) {
  return languageCodes
    .map(x => x.split('-')[0])
    .filter(x => !!languages[x])[0];
}

function getFullLanguageCode(languageCode) {
  switch (languageCode) {
    case 'da':
      return 'da-DK';
    case 'en':
      return 'en-US';
    default:
      throw new Error(`Unknown language code: ${languageCode}`);
  }
}

function getTranslationModule(modulePath, language) {
  const parentProps = modulePath.split('/').filter(key => key !== '');
  return parentProps.reduce(
    (val, key) => ((val && val[key]) ? val[key] : null),
    getDictionary(language)
  );
}

export {
  allowedLanguages,
  getTranslationModule,
  getTranslatedText,
  getDefaultLanguageCode,
  getFullLanguageCode,
  readLanguageFromUrl,
  findSupportedLanguageCode,
  isSupported
};